export function SectionHeader({
  kicker,
  title,
  desc,
  align = 'left',
  link,
}: {
  kicker?: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
  link?: { label: string; href: string };
}) {
  return (
    <div
      className={`mb-7 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between md:mb-9 ${
        align === 'center' ? 'sm:flex-col sm:items-center sm:text-center' : ''
      }`}
    >
      <div>
        {kicker && (
          <p className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-primary-500">
            <span className="h-px w-6 bg-primary-400"></span>
            {kicker}
          </p>
        )}
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-[32px] md:leading-tight">
          {title}
        </h2>
        {desc && (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{desc}</p>
        )}
      </div>
      {link && (
        <a
          href={link.href}
          className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-500"
        >
          {link.label}
          <i className="ri-arrow-right-line"></i>
        </a>
      )}
    </div>
  );
}